import Favorites from "./favorites"
import GeneralHelper from "./generalHelper"
import ColorHelper from "./colorHelper"
import { BrowsingInstance } from "./AppInstance"
import Category from "./category"
import Pattern from "./pattern"
import MetaFiles, { General, Ids, Type } from "./metafiles"
import EventSubscriber from "./eventSubscriber"
import Search from "./search"
import PatternBuilderCart from "./PatternBuilderCart"

export default class View {
  static update_ui() {
    switch(window.AppInstance.browsing())
    {
      case BrowsingInstance.root:
        View.collection_home();
        View.toggle_select_colors_section(true);
        View.toggle_headline(false);
        View.hide_toolbars_tools();
        View.hide_logo_copyright();
        View.toggle_table_select(true);
        View.toggle_export_async(false);
        View.toggle_download(window.AppInstance.instance().SHOW_DOWNLOAD);
        View.toggle_search_box();
        $("#BrowserHeading").html("Select a collection to get started").css("display", "inline-block");
        window.PatternBuilderCart.refreshQtyStep(true);
        //$('.choose-collection-link').click();
        View.resize();
      break;
      case BrowsingInstance.category:
        View.toggle_select_colors_section(true);
        View.toggle_headline(true);
        View.hide_toolbars_tools();
        View.hide_logo_copyright();
        View.toggle_table_select(true);
        View.toggle_download(false);
        View.toggle_export_async(false);
        View.toggle_search_box();
        //$("#BrowserHeading").html("Select a category").css("display", "inline-block");
        //$('#choose-pattern-link').click();
        //$('.choose-pattern-link').click();
        window.PatternBuilderCart.refreshQtyStep(true);
        View.resize();
      break;
      case BrowsingInstance.pattern:
        View.toggle_select_colors_section(window.AppInstance.instance().is_raster);
        View.toggle_headline(true);
        View.show_toolbars_tools();
        //GeneralHelper.zoom_bar_set(parseInt(window.AppInstance.instance().selected.metadata.get('thumbZoom')));
        View.show_logo_copyright(window.AppInstance.instance().category_metafiles.copyrights_text, window.AppInstance.instance().category_metafiles.pattern_name_text);
        View.toggle_table_select(false);
        View.toggle_download(window.AppInstance.instance().SHOW_DOWNLOAD);
        View.toggle_search_box();
        View.toggle_export_async(false);
        //$('#choose-pattern-link').click();
        View.toggle_no_patterns_message();
        window.PatternBuilderCart.refreshQtyStep(true);
        //toggle_add_to_favs();
        //$('.choose-color-link').click();
        View.resize();
      break;
    }
  }
  
  static reset()
  {
    View.resetPatternBuilder();
  }

  static toggle_export_async(show) {
    if (show)
      $('#export-async-button').show();
    else
      $('#export-async-button').hide();
  }

  static toggle_download(show) {
    if (show)
      $('#download-button').show();
    else
      $('#download-button').hide();
  }

  static wizardLoading(patterns, canvas, loading) {
    let loadingElements = [];
    if (patterns) {
        loadingElements.push("#pattern-steps");
    }
    if (canvas) {
        loadingElements.push("#CadXCanvas");
    }
    //$(window.PatternBuilder.config().WIZARD_CONTAINER).find(loadingElements.join(","))[loading ? "addClass" : "removeClass"]("element-loading");
    loadingElements.forEach(function(el) {
      $(el)[loading ? "addClass" : "removeClass"]("element-loading")
    });
}

  static toggle_favorites_button()
  {
    let tuple ;
    if (!window.AppInstance.instance().is_raster)
      tuple = JSON.stringify(ColorHelper.get_swatches_spotcolor_tuples(window.AppInstance.instance().canvas.figures[0])) ;
    else
      tuple  = window.AppInstance.instance().selected.ExternalId ;

    $('#add-to-favorites').css('visibility', Favorites.can_be_added(tuple) ? 'visible' : 'hidden');
  }

  static toggle_search_box()
  {
      if ( window.AppInstance.is_category() || window.AppInstance.is_design_house() )
      {
        $('.search-options').show();
        if ( window.AppInstance.is_category() )
          $('.search-inside-sub-label').html('Category');
        else if ( window.AppInstance.is_design_house() )
          $('.search-inside-sub-label').html('Collection');
      }
      else{
        View.reset_search_box();
      }
  }

  static toggle_add_to_favs()
  {
    if ( ! window.AppInstance.instance().selected.is_favorite )
    {
      $('#pattern-favorite-header').hide();
      $('#pattern-favorite-set').hide();
      $('#add-to-favorites').hide();
    }
    else{
      $('#pattern-favorite-header').show();
      $('#pattern-favorite-set').show();
      $('#add-to-favorites').show();
    }
  }

  static toggle_no_patterns_message()
  {
    if ( window.AppInstance.instance().favorites.length > 0 )
      $('#noPatternMessage').hide();
    else
      $('#noPatternMessage').show();
  }

  static reset_search_box()
  {
    $('.search-options').hide();
  }

  static toggle_table_select(hide) {
    if (!hide) {
      $(".pattern-tab > a").removeClass("disabled-btn");
      $(".tab-content.choose-pattern .steps-nav .next-step").show();
      //window.PatternBuilderCart.refreshQtyStep(true);
    } else {
      var patternTab = window.AppInstance.instance().path && window.AppInstance.instance().path.split(/[/]+/).length > General.category_root_level ? ".pattern-tab:not(.choose-collection, .choose-pattern) > a" : ".pattern-tab:not(.choose-collection) > a";
      $(".pattern-tab > a").removeClass("disabled-btn");
      $(patternTab).addClass("disabled-btn");
      $(".tab-content.choose-pattern .steps-nav .next-step").hide();
    }
  }

  static show_logo_copyright(copyright_text, pattername_text) {
    $(".expanded-pattern .logo").show();
    $(".expanded-pattern .copyright").html(copyright_text).show();
    $(".expanded-pattern .expanded-title").text(pattername_text).show();
  }

  static hide_logo_copyright() {
    $(".expanded-pattern .logo").html("").hide();
    $(".expanded-pattern .copyright").html("").hide();
    $(".expanded-pattern .expanded-title").html("").hide();
  }

  static toggle_colorway_copy(target) {
    if ($('#' + target).find(".colorway").length > 1) {
      $(".color-combo-heading span.mult-color-combo").show();
      $(".color-combo-heading span.one-color-combo").hide();
    } else {
      $(".color-combo-heading span.mult-color-combo").hide();
      $(".color-combo-heading span.one-color-combo").show();
    }
  }

  static toggle_select_colors_section(hide) {
    if (hide) {
      $(".select-colors-section").hide();
      $(".color-combo-heading span.has-select-colors").hide();
      $(".color-combo-heading span.no-select-colors").show();
    } else {
      $(".select-colors-section").show();
      $(".color-combo-heading span.has-select-colors").show();
      $(".color-combo-heading span.no-select-colors").hide();
    }
  }

  static toggle_headline(hide)
  {
    if (hide)
      $("#pattern-builder-headline").hide();
    else
      $('#pattern-builder-headline').css('display', 'table');
  }

  static hide_toolbars_tools()
  {
      $('#rulerBarY').hide();
      $('#rulerBarX').hide();
      window.AppInstance.instance().canvas.container.style.pointerEvents = 'none';
      $('.toolbar-container').hide();
  }

  static show_toolbars_tools()
  {
    $('#rulerBarY').show();
    $('#rulerBarX').show();
    window.AppInstance.instance().canvas.container.style.pointerEvents = '';
    $('.toolbar-container').show();
  }

  static update_colorpickers()
  {
      //TODO: update selected app instance colormap
    Cx_.forEach($(".combo-color-select"), function(picker){
      var name = $(picker).find("input[name=selectedName]").val() ;
      var hex  = $(picker).find("input[name=selectedHex]").val();
      GeneralHelper.change_swatch(picker, hex, name);
    });
    View.update_preview_swatches();
  }

  static update_loaded_colorpickers(colors, pickers)
  {
      //TODO: update selected app instance colormap
    Cx_.forEach(colors, function(c, i){
      $(pickers[i]).find("input[name=selectedName]").val(c.ReplacedColorHex) ;
      $(pickers[i]).find("input[name=selectedHex]").val(c.ReplacedColorName);
      GeneralHelper.change_swatch(pickers[i], c.ReplacedColorHex, c.ReplacedColorName);
    });
    View.update_preview_swatches();
  }

  static resize() {
    var height = document.getElementsByTagName("html")[0].scrollHeight;
    if ( window.parent )
      window.parent.postMessage(["setHeight", height], "*"); 
  }

  static build_colorpickers(color_zones) {
    var colorpickerHTML = '{{#each ColorZones}}<div class="promos wizard-option wizard-shadow combo-color-select" onclick="window.open_digital_palette(this);" data-selectedname="{{name}}" title="{{name}}">';
    colorpickerHTML += '<input name="selectedHex" type="hidden" value="{{hex}}" />';
    colorpickerHTML += '<input name="selectedName" type="hidden" value="{{name}}" />';
    colorpickerHTML += '<input name="prevHex" type="hidden" value="{{prevHex}}" />';
    colorpickerHTML += '<input name="prevName" type="hidden" value="{{prevName}}" />';
    colorpickerHTML += '<input name="origHex" type="hidden" value="{{prevHex}}" />';
    colorpickerHTML += '<input name="origName" type="hidden" value="{{prevName}}" />';
    colorpickerHTML += '<div class="wiz-opt-container"><div class="top"><div class="main-section"><div class="pattern-color" style="background-color:#{{hex}};"></div></div></div><div class="bottom"><div class="caption-container"><div class="caption holds-check">{{{name}}}</div></div></div></div></div>{{/each}}';
    var colorSummaryHTML = '{{#each ColorZones}}<div><span class="colorName">{{{name}}}</span><div class="previewColorSwatch preview-color-swatch" style="background-color: #{{hex}};"></div></div>{{/each}}';
    var $colorpickers = $(".choose-color-swatch .promo-masonry");
    var colorZones = [];

    ColorHelper.consolidate_color_zones( color_zones );
    //should be already consolidated from D3 import
    var color_sets = JSON.parse(window.AppInstance.instance().selected.metadata.get('colorSet'))[0] ;
    color_sets.Color = Cx.isArray(color_sets.Color) ? color_sets.Color : [color_sets.Color];

    Cx_.forEach(color_sets.Color, function (color, i) {
        if ( ( color.ColorName == null ) || ( color.ColorName.length == 0 ) )
            color.ColorName = ColorHelper.hexaToNameFindAny(color.RGB);
        if ( ( color.ColorName !== null ) && ( color.ColorName.length > 0 ) )
        {
          colorZones.push({
            index: i+1,
            hex: $.trim(color.RGB),
            name: $.trim(color.ColorName),
            prevHex: $.trim(color.RGB),
            prevName: $.trim(color.ColorName),
            hex: $.trim(color.RGB),
            name: $.trim(color.ColorName),
            origHex: $.trim(color.RGB),
            origName: $.trim(color.ColorName)
          });

          window.AppInstance.instance().selected.colors.push({ name: 'color' + String(i+1), tag: color.Tag });
        }
    });

    if (colorZones.length > 0) {
      View.toggle_select_colors_section(false);
    } else {
      View.toggle_select_colors_section(true);
    }

    $colorpickers.html(Handlebars.compile(colorpickerHTML)({ ColorZones: colorZones }));
    //$colorpickers.find(".caption").dotdotdot({ ellipsis: "...",  wrap: "letter"});
    $(".summary-colors").html(Handlebars.compile(colorSummaryHTML)({ ColorZones: colorZones }));
  }

  static get_viewport_dimensions() {
    let x = 0 ;
    let y = 0; 
    if (window.self === window.top) {
      x = window.innerWidth ;
      y = window.innerHeight;
    } else {
      // This is an iframe
      x = window.AppInstance.instance().FRAME_WIDTH;
      y = window.AppInstance.instance().FRAME_HEIGHT;
    }
    return { x: document.body.clientWidth, y }
  }

  static open_digital_palette(colorpicker) {
    var colorPalette = '<div id="wizard-container" class="digital-palette"><span class="fa fa-close" onclick="$.colorbox.close();"></span><div class="color-swatches">{{#each Colors}}<div class="wizard-option upload-color {{#if selected}}active{{/if}}" onclick="window.palette_select_color(this, {{@root.Index}}, \'{{hex}}\')" style="background-color:#{{hex}};"><span>{{name}}</span></div>{{/each}}</div></div>';
    var colorIndex = $(colorpicker).index();
    var selectedColor = $(colorpicker).find("input[name=selectedHex]").val();
    var selectedColorName = $(colorpicker).find("input[name=selectedName]").val();
    var colorSets = [];

    var sub_color_set = window.AppInstance.instance().color_set[ $('select[id=palette-drop-down]').val() ] ;

    for (var i = 0, len = sub_color_set.length; i < len; i++) {
      colorSets.push({
        selected: sub_color_set[i].hex == selectedColor || sub_color_set[i].name == selectedColorName,
        hex: sub_color_set[i].hex,
        name: sub_color_set[i].name
      });
    }

    GeneralHelper.open_color_box(Handlebars.compile(colorPalette)({ Colors: colorSets, Index: colorIndex }), function() {
      var maxHeight = Math.max.apply(null, $(".digital-palette .upload-color:visible span").map(function () {
          return $(this).height();
      }).get());
      $(".digital-palette .upload-color:visible span").height(maxHeight);
    }, { width:  ( document.body.clientWidth * 0.9 ) + "px"}, GeneralHelper.is_mobile() );
  }

  static palette_select_color(color, index, hex) {
    window.AppInstance.instance().currentViewTransform = Cx.cloneDeep(window.AppInstance.instance().canvas.viewTransform) ;
    $("#pattern-default-sets .colorway").removeClass("active");
    $(".digital-palette .color-swatches .upload-color").removeClass("active");
    $(color).addClass("active");
    $.colorbox.close();
    var prevHex = $(".choose-color-swatch .promo-masonry .promos").eq(index).find("input[name=selectedHex]").val();
    var prevName = $(".choose-color-swatch .promo-masonry .promos").eq(index).find("input[name=selectedName]").val();
    View.wizardLoading(true, true, true);
    $(".choose-color-swatch .promo-masonry .promos").eq(index).find("input[name=selectedHex]").val(hex);
    $(".choose-color-swatch .promo-masonry .promos").eq(index).find("input[name=selectedName]").val(color.innerText);
    $(".choose-color-swatch .promo-masonry .promos").eq(index).find("input[name=prevHex]").val(prevHex);
    $(".choose-color-swatch .promo-masonry .promos").eq(index).find("input[name=prevName]").val(prevName);
    ColorHelper.change_color($('.choose-color-swatch .promo-masonry .promos'));

    window.AppInstance.instance().canvas.zoomTo(window.AppInstance.instance().currentViewTransform.zoom, window.AppInstance.instance().currentViewTransform.center);
    Pattern.render_pattern$().then(function(){
      View.update_colorpickers();
      View.wizardLoading(true, true, false);
      PatternBuilderCart.resetCartButton();
    })
    .catch(function(e) {
      GeneralHelper.errorOut(e);
    });
  }

  static update_preview_swatches()
  {
    if ( ! window.AppInstance.instance().ARTWORKUPLOADER )
    {
      $('.summary-colors')[0].innerHTML = '';
      if (!window.AppInstance.instance().is_raster)
      {
        var pickers = $('.choose-color-swatch .promo-masonry .promos') ;
        var content ='';
        Cx_.forEach(pickers, function(p){
          var name = $(p).find("input[name=selectedName]").val() ;
          var hex  = $(p).find("input[name=selectedHex]").val();
          content += '<div><span class="colorName">'+name+'</span><div class="previewColorSwatch preview-color-swatch" style="background-color: #'+hex+';"></div></div>';
        });
      }
      else {
        content = '<div><span class="variation-name">'+window.AppInstance.instance().selected.variationName+'</span><div class="previewColorSwatch preview-color-swatch" style="background-image: url('+window.AppInstance.instance().selected.thumb_url+');"></div></div>';
      }
      $('.summary-colors')[0].innerHTML = content;
    }
  }

  static collection_home(preventReset) {
    if ( preventReset ) {
      $('.choose-collection-link').click();
    }
    else { 
      window.AppInstance.reset();
      View.reset_search_box();
      $("#wizard-container .tab-list li a").removeClass("selected");
      $("#pattern-steps .tab-content:visible").hide();
      $("#pattern-steps .choose-collection").show();
      $("#wizard-container .tab-list li.choose-collection a").addClass("selected");
    }    
  }

  static show_maintenance() {
    $("#pattern-builder-headline").css("display","table").find("span").html('<span class="headline-container"><span>Sorry, we\'re under maintenance.<br />Please check back soon!</span></span>');
    $("#pattern-builder-maintenance").show();
    $(".browser-container").hide();
    $("#BrowserHeading").html("");
    $(".steps-nav").hide();
    $(".pattern-tab > a").addClass("disabled-btn");
  }

  static clear_metafiles()
  {
    $('#'+Ids.logo).remove();
    $('#'+Ids.header).remove();
    $('#'+Ids.copyrights).remove();
    $('#'+Ids.pattern_name).remove();
  }

  static show_step_two()
  {
    $("#wizard-container .tab-list li a").removeClass("selected");
    $("#pattern-steps .tab-content:visible").hide();
    $("#pattern-steps .choose-pattern").show();
    $("#wizard-container .tab-list li.choose-pattern a").removeClass("disabled-btn").addClass("selected");
  }

  static render_header$(parent) 
  {
    if ( window.AppInstance.instance().is_fav_search ) {
      return Cx.resolve();
    }else{
      let p = ( window.AppInstance.is_root() && !window.AppInstance.instance().is_fav_search ) ?
      MetaFiles.load_default_header$() :
      MetaFiles.load_metafiles_type$(parent, Type.header_document) ;

      return p.then(function(header){
      header = Array.isArray(header) ? header.shift() : header ;
        return MetaFiles.create_header_metafile$(header).then(function() {
          return MetaFiles.render_floating_header$(window.AppInstance.instance().category_metafiles.header) ;
        });
      })
    }
  }

  static load_content$(element, parent, is_fav_search, prevent_ui_update)
  {
    View.toggle_search_box();

    window.AppInstance.instance().is_fav_search = is_fav_search ;
    window.AppInstance.instance().path = parent ;

    let bigThumbs = false ;

    if (( parent.split(/[/]+/).length == 4 ) && (window.AppInstance.instance().GROUPID == null)) //main design house
    {
      window.AppInstance.instance().selected.id = "";
      window.AppInstance.instance().m_patterns = [];
    }
    else if ( parent.split(/[/]+/).length == 3 )
    {
      bigThumbs = true ; //root design houses vs sub categories / pattern icons
    }

    if ( ! prevent_ui_update )
      View.update_ui();

    $('.browser-container').html(MetaFiles.get_browser(element, parent));

    View.wizardLoading(true, true, true);

    return Category.load_children$(parent).then(function(content) {

      PatternBuilderCart.resetCartButton();

      content = content.Items ;
      //const meta = Category.get_meta_files(content);
      let patterns = content ; //.filter(n => !meta.includes(n));

      $(".noFavorites").hide();

      if ( patterns.length > 0 )
        patterns = Cx_.filter( patterns, function(p) { return ( Pattern.is_valid_pattern(p) ); });

      if ( ( patterns.length == 0 ) && (window.AppInstance.instance().is_fav_search) )
        $(".noFavorites").show();

      var target = ( window.AppInstance.is_root() && !window.AppInstance.instance().is_fav_search ) ? 'collection-squares' : 'pattern-squares' ;
      $('#' + target ).html("");

      let p = [];

      if ( ! prevent_ui_update )
        p.push(View.render_header$(parent));

      return Cx.whenAll(p).then(function(){
        if ( patterns.length > 0 )
        {
          Pattern.process('pattern-squares', patterns, true);
          if (!window.AppInstance.instance().is_fav_search)
            $('#BrowserHeading').html("Select a pattern");

          if ( ! prevent_ui_update )
            $('#select-pattern').click()  
        }
        else{
          return Category.process$( target , parent, true, bigThumbs ).then(function() {
            $('#BrowserHeading').html("Select a category");            
  
            if ( window.AppInstance.instance().DEFAULTCATEGORY )
            {
              window.load_content$('collection-squares', window.AppInstance.instance().DEFAULTCATEGORY, false ).then(function() {
                window.AppInstance.instance().DEFAULTCATEGORY = null ;
                View.update_ui();
              });
            }

            if ( ! prevent_ui_update )
              $('#select-pattern').click();
  
            // if ( window.AppInstance.instance().DEFAULTPATTERNID )
            //   window.load_content$('pattern-squares', window.AppInstance.instance().DEFAULTCATEGORY, null, true, true);
          });          
        }
      });
  //});
    })
    .catch(function(e) {
      GeneralHelper.errorOut(e);
    });
  }

  static checkResetPatternBuilder() {
    GeneralHelper.open_general_box({
      templateName: "info_modal",
      back: false,
      heading: "Start Over?",
      content: '<p>If you start over, all selections will be cleared and you will be taken back to home.</p><p>Do you want to start over?</p>',
      buttons: '<a class="cancel-button" onclick="$.colorbox.close();">No, cancel</a><a class="orangeButton" onclick="window.resetPatternBuilder();">Yes, start over</a>'
    });
  }

  static loadPattern$(id)
  {
    return Pattern.load_pattern_and_metafiles(id, true).then(function() {
      //$('#select-color').click();
      if (window.AppInstance.instance().editParams && window.AppInstance.instance().editParams.jobData && window.AppInstance.instance().editParams.jobData.description && window.AppInstance.instance().editParams.jobData.description.colors && window.AppInstance.instance().editParams.jobData.description.colors.length > 0) {
        var swatches = $('.choose-color-swatch .promo-masonry .promos');
        View.update_loaded_colorpickers(window.AppInstance.instance().editParams.jobData.description.colors, swatches);
        ColorHelper.change_color(swatches);
      }
      View.wizardLoading(true, true, false);
      View.update_preview_swatches();
      View.update_ui();

      var selectedTag = window.AppInstance.instance().selected.Tags && window.AppInstance.instance().selected.Tags.length > 0 ? window.AppInstance.instance().selected.Tags[0].Name : undefined;
      var parentID = window.AppInstance.instance().selected.metadata.get('parentDocumentID');

      if (parentID) { //Shed off last folder in path
        selectedTag = selectedTag.replace(/[/][^/]*$/, "");
      }

      let target = selectedTag || CONFIG.PatternBuilderSetName.replace(/[/]$/, "") ;

      return View.load_content$('pattern-squares', target, false, true);
    });
  }

  static resetPatternBuilder() {

    var patternToLoad = window.AppInstance.pattern_to_load();
    window.AppInstance.instance().jobData = window.AppInstance.instance().editParams.jobData ;

    if ( ( patternToLoad == undefined ) && ( window.AppInstance.instance().DEFAULTPATTERNID  ) )
      patternToLoad =  window.AppInstance.instance().DEFAULTPATTERNID ;

    View.loadStartup().then(function() {
      if ( patternToLoad )
      {
        View.loadPattern$(patternToLoad).then(function() {
          window.PatternBuilderCart.Init("#wizard.pattern-builder .wizard-sections-container");
          $('#select-pattern').click();
          console.log('App started.');
        })
      }
    })
    .catch(function(e) {
      GeneralHelper.errorOut(e);
    });
  }

  static loadStartup()
  {
    var reset_path = window.AppInstance.instance().previous_path;
    var reset_collection = false ;
    window.AppInstance.instance().active_search = false ;
    window.AppInstance.instance().m_patterns = [];
    window.AppInstance.reset_selected()

    if ( !reset_path || ( window.AppInstance.browsing() === BrowsingInstance.root ) )
    {
      reset_path = window.PatternBuilder.config().SETNAME.replace(/[/]$/,"") ;
      reset_collection = true ;
    }

    return View.load_content$('pattern-squares', reset_path, false ).then(function() {
      $("input.numbers-only").val("");
      //window.PatternBuilderCart.getTotalPricing(); 
      if ( reset_collection )
        $("li.choose-collection a").click();
      $.colorbox.close();
      //subscribe events
      EventSubscriber.Subscribe();
      Search.Subscribe();
      $(".pattern-tab > a").addClass("disabled-btn");  
      window.PatternBuilderCart.refreshQtyStep();    
    });
  }

  static toggleTabSelect() {
    if (typeof(window.AppInstance) !== "undefined" && window.AppInstance.instance().ExternalId && window.AppInstance.instance().selected.ExternalId != "") {
      $(".pattern-tab > a").removeClass("disabled-btn");
      $(".tab-content.choose-pattern .steps-nav .next-step").show();
      //window.PatternBuilderCart.refreshQtyStep(true);
    } else {
      var patternTab = window.AppInstance.instance().path && window.AppInstance.instance().path.split(/[/]+/).length > General.category_root_level ? ".pattern-tab:not(.choose-collection, .choose-pattern) > a" : ".pattern-tab:not(.choose-collection) > a";
      $(".pattern-tab > a").removeClass("disabled-btn");
      $(patternTab).addClass("disabled-btn");
      $(".tab-content.choose-pattern .steps-nav .next-step").hide();
    }
  }

  static initialize_pattern_builder() {
    View.toggleTabSelect();
    if (window.AppInstance.instance().GROUPID && window.AppInstance.instance().SHOPPERID) {
      $.ajax({
        type: "GET",
        url: STAHLS_API_BASE + (window.AppInstance.instance().SHOPPERID ? "shoppers/" + window.AppInstance.instance().SHOPPERID + "/" : "") + "cart/groups" + (window.AppInstance.instance().GROUPID ? "/" + window.AppInstance.instance().GROUPID : ""),
        crossDomain: true,
        contentType: "application/json"
      }).then(function(data) {
        if (data) {
        $(".shopAdd").addClass("update-group");
        editParams.jobData = data.jobData;
        if (data.items) {
          editParams.items = {};
        for (var i = 0, len = data.items.length; i < len; i++) {
          var sku = $.trim(data.items[i].sku);
          var uofm = $.trim(data.items[i].unitOfMeasure);
          var qty = $.trim(data.items[i].quantity);
          if (typeof(editParams.items[sku]) === "undefined") {
            editParams.items[sku] = {};
          }
          editParams.items[sku][uofm] = qty;
          }
        }
        }
        bindPatternBuilderEvents();
      }).fail(function() { // Group ID does not exist
        GROUPID = undefined;
        bindPatternBuilderEvents();
      });
    } else {
      bindPatternBuilderEvents();
    }
    var handlePatternBuilderResize = function() {
      if (typeof(AppInstance) !== "undefined" && window.AppInstance.instance().canvas) {
        window.AppInstance.instance().canvas.updateSize();
        window.AppInstance.instance().rulerX.updateSize();
        if (window.AppInstance.instance().selected.id.length == 0) {
          Metafiles.handle_metafiles$(window.AppInstance.is_root() ? "/" : window.AppInstance.instance().path);
        }
      }
    };
  }
}

